import { useTranslation } from 'react-i18next';

import { Alert, Form } from 'ui';
import { ApprovalAlert } from './approval-alert';

type EventInviteesAlertFormValues = {
  alertExceededInvitees: boolean;
};

type P = {
  exceededApprovedInviteesLimit?: number;
  isAdmin: boolean;
  isEventApproved: boolean;
  totalInvitees: number;
};

const EventInviteesAlert = ({ exceededApprovedInviteesLimit, isAdmin, isEventApproved, totalInvitees }: P) => {
  const { t } = useTranslation();

  const isExceededLimitAlertVisible = Boolean(exceededApprovedInviteesLimit);
  const isApprovalNeededAlertVisible = !isEventApproved && totalInvitees > 25;

  return (
    <Form.Item<EventInviteesAlertFormValues>
      className="event-invitees-exceeded-limit"
      name="alertExceededInvitees"
      noStyle={!isExceededLimitAlertVisible && !isApprovalNeededAlertVisible}
      rules={[
        {
          message: '',
          required: true,
          validator: async () =>
            isExceededLimitAlertVisible
              ? Promise.reject(new Error('Number of invitees exceeded limit'))
              : Promise.resolve(),
        },
      ]}
    >
      {isExceededLimitAlertVisible ? (
        <Alert
          description={t(
            'The number of invitees cannot be increased, beyond the specified limit, in the published event.',
            { number: exceededApprovedInviteesLimit },
          )}
          title={t('More than {{ count }} invitees', {
            count: exceededApprovedInviteesLimit,
          })}
          type="warning"
        />
      ) : null}
      {isApprovalNeededAlertVisible ? <ApprovalAlert isAdmin={isAdmin} /> : null}
    </Form.Item>
  );
};

export default EventInviteesAlert;
